<template>
  <el-row style="height: 100vh;">
    <el-col :span="14" style="height: 95%;">
      <el-row style="height: 100%;">
        <span>{{str}}</span>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
  import API from "../api/api_user";
  import Cookies from "js-cookie"
  import base64 from '../common/base64'
  import area_api from "../api/api_common"

  export default {
    name: "login-go",//免密登录
    data() {
      return {
        loading: false,
        loadingObj: "",
        str: "登录..."
      };
    },
    methods: {
      openFullScreen() {
        this.loadingObj = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      async doLogin() {
        let userParams = this.$route.query.logindto;
        var userInfo = base64.decodeBase64Content(userParams);
        var userInfo1 = JSON.parse(decodeURIComponent(userInfo));


        // var userInfo1 = JSON.parse(userInfo);
        // {"username":"admin","pwd":"admingykj1234","url":"/bigScreen"}
        // http://localhost:8081/#/loginGo?logindto=JTdCJTIydXNlcm5hbWUlMjIlM0ElMjJhZG1pbiUyMiUyQyUyMnB3ZCUyMiUzQSUyMmFkbWluZ3lrajEyMzQlMjIlMkMlMjAlMjJkZXB0SWQlMjIlM0ElMjAlMjIlMjIlMkMlMjJ1cmwlMjIlM0ElMjIvYmlnU2NyZWVuJTIyJTdE
        // http://localhost:8081/#/loginGo?logindto=JTdCJTIydXNlcm5hbWUlMjIlM0ElMjJhZG1pbiUyMiUyQyUyMnB3ZCUyMiUzQSUyMmFkbWluZ3lrajEyMzQlMjIlMkMlMjJ1cmwlMjIlM0ElMjIvYmlnU2NyZWVuJTIyJTdE
       // http://localhost:8081/#/loginGo?logindto=JTdCJTIydXNlcm5hbWUlMjIlM0ElMjJxeSUyMiUyQyUyMnB3ZCUyMiUzQSUyMjEyMzQ1NiUyMiUyQyUyMnVybCUyMiUzQSUyMi9iaWdTY3JlZW4lMjIlN0Q=
       //  http://localhost:8081/#/loginGo?logindto=JTdCJTIydXNlcm5hbWUlMjIlM0ElMjJhZG1pbl95eCUyMiUyQyUyMnB3ZCUyMiUzQSUyMjEyMzQ1NiUyMiUyQyUyMnVybCUyMiUzQSUyMi9iaWdTY3JlZW4lMjIlN0Q=
        let that = this;
        that.loading = true;
        let loginParams = base64.encodeBase64Content(JSON.stringify({
          username: userInfo1.username || 'admin_yx',
          pwd: userInfo1.pwd||'123456',
          deptId: userInfo1.deptId||"230101"
        }))
        try {
          let result = await API.login({"logindto": loginParams});
          // console.log(result);
          if (result && result.code === 0) {
            that.$store.commit('LOGIN', result)
            that.$router.push({path: userInfo1.url});
            this.getNextXzqData(Cookies.get('curAreaCode'));//获取乡级以上行政区信息
          } else {
            that.GLOBAL.warning(result.msg || "登录失败!");
          }
        } catch (err) {
          console.error("登录失败!");
        } finally {
          that.loading = false;
        }
      },


      async getNextXzqData(areaCode) {//获取乡级以上行政区信息
        let areaDataOption1 = [];
        let areaR = area_api.getXzqData({areaCode: areaCode, userAreaCode: 1});
        let areaData = await areaR;
        if(areaData.code!=0){
          localStorage.setItem("areaOptions","");
          return;
        }
        areaDataOption1 = areaData.data[0];
        if (areaData.data[0].arealevel == "乡级") {  //若为乡级 则直接返回数据
          localStorage.setItem("areaOptions",JSON.stringify(areaDataOption1));
          return;
        }

        if (areaData.data[0].arealevel == "县级") { //若为县级 则返回子级数据
          localStorage.setItem("areaOptions",JSON.stringify(areaDataOption1));
          return;
        }

        if (areaData.data[0].arealevel == "地市级") { //若为地市级 则返回子级数据
          let areaDataOption2 = areaData.data[0].children;
          for (var c = 0; c < areaDataOption2.length; c++) {
            let areaR2 = area_api.getXzqData({areaCode: areaDataOption2[c].qhdm, userAreaCode: 1});
            let areaData2 = await areaR2;
            areaDataOption1.children[c].children = areaData2.data[0].children;
          }
          localStorage.setItem("areaOptions",JSON.stringify(areaDataOption1));
          return;
        }
        if (areaData.data[0].arealevel == "省级") { //若为省级 则返回子级数据
          let areaDataOption2 = areaData.data[0].children;
          for (var c = 0; c < areaDataOption2.length; c++) {
            let areaR2 = area_api.getXzqData({areaCode: areaDataOption2[c].qhdm, userAreaCode: 1});
            let areaData2 = await areaR2;
            areaDataOption1.children[c].children = areaData2.data[0].children;

            let areaDataOption3 = areaDataOption1.children[c].children;
            for (var v = 0; v < areaDataOption3.length; v++) {
              let areaR3 = area_api.getXzqData({areaCode: areaDataOption3[v].qhdm, userAreaCode: 1});
              let areaData3 = await areaR3;
              areaDataOption1.children[c].children[v].children = areaData3.data[0].children;
            }
          }
          localStorage.setItem("areaOptions",JSON.stringify(areaDataOption1));
          return;
        }
      },
  },
  mounted(){
    // this.handleGo();
    this.doLogin()
      }
  };
</script>




// WEBPACK FOOTER //
// src/studio/loginGo.vue